export default __webpack_public_path__ + "static/media/twitter.c6750796.svg";